import React from 'react';

import { ButtonColour } from 'components/Button/constants';
import { ContentTypesType } from './types';
import {
  getDateFormatted,
  getLink,
  linkText,
  readTimeText,
} from 'modules/utils/utils';
import { RESOURCE_HUB_URL } from 'modules/utils/constants';
import ResourceHubItem from 'components/ResourceHubItem';
import CtaButton from 'components/Cta/Button';

import styles from './styles.module.scss';
import Skeleton from './Skeleton';
import { SocialMediaCard } from 'components/CMSModals/socialMediaCard';

export type ContentTypesListProps = {
  buttonLabel?: string;
  contentTypeName?: string;
  socialMediaCards?: SocialMediaCard[];
  data?: ContentTypesType[];
  loaded: boolean;
  title?: string;
};

const ContentTypesList: React.FunctionComponent<ContentTypesListProps> = ({
  buttonLabel,
  contentTypeName,
  data,
  loaded,
  title,
  socialMediaCards,
}) => {
  contentTypeName = contentTypeName ? contentTypeName : ' ';
  return loaded && socialMediaCards ? (
    <React.Fragment>
      {socialMediaCards && socialMediaCards.length > 0 && (
        <div className={styles.contentTypeList}>
          {title && <h2>{title}</h2>}
          <ul>
            <li>
              {socialMediaCards.map(
                (contentType: SocialMediaCard, index: number) => (
                  <ResourceHubItem
                    bookmarked={contentType.isSaved}
                    buttonLabel={linkText(contentType.navText)}
                    description={contentType.description}
                    image={contentType?.imageUrl}
                    key={`content-types-${index}`}
                    liked={contentType.isLiked}
                    likes={contentType.likeCount}
                    publicationDate={getDateFormatted(
                      contentType.publicationDate.toString(),
                    )}
                    readTimeText={readTimeText(contentType.navLink)}
                    slug={`${RESOURCE_HUB_URL}${contentType.navLink}`}
                    timeToRead={contentType.readingTime}
                    title={contentType.title}
                    uid={contentType.title}
                    contentRowKey={contentType.contentRowKey}
                  />
                ),
              )}
            </li>
          </ul>
          {contentTypeName && buttonLabel && (
            <div>
              <CtaButton
                defaultColour={ButtonColour.BRAND_BERRY}
                label={buttonLabel}
                custom_url={`${RESOURCE_HUB_URL}${contentTypeName}`}
                small
              />
            </div>
          )}
        </div>
      )}
    </React.Fragment>
  ) : (
    <Skeleton />
  );
};

export default ContentTypesList;
